var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"ml-4",attrs:{"items":_vm.months(),"item-text":"value","item-value":"key","menu-props":"auto","hide-details":"","label":_vm.monthSelected.value,"single-line":""},model:{value:(_vm.monthSelected),callback:function ($$v) {_vm.monthSelected=$$v},expression:"monthSelected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }